export const FABRIC_SKU = {
  'Residential-Galvanized-3':   '21411123G',
  'Residential-Galvanized-3.5': '214111242G',
  'Residential-Galvanized-4':   '21411124G',
  'Residential-Galvanized-5':   '21411125G',
  'Residential-Galvanized-6':   '21411126G',
  'Commercial-Galvanized-3':    '293G',
  'Commercial-Galvanized-3.5':  '2942G',
  'Commercial-Galvanized-4':    '294G',
  'Commercial-Galvanized-5':    '295G',
  'Commercial-Galvanized-6':    '296G',
  'Commercial-Galvanized-7':    '297G',
  'Commercial-Galvanized-8':    '298G',
  'Commercial-Galvanized-10':   '2910G',
  'Commercial-Galvanized-12':   '2912G',
  'Black-3':   '293BK',
  'Black-3.5': '2942BK',
  'Black-4':   '294BK',
  'Black-5':   '295BK',
  'Black-6':   '296BK',
  'Black-8':   '298BK',
  'Black-10':  '134910BK',
  'Black-12':  '2912BK',
};

export const POST_SKU = {
  "Galv-1-5/8\" x 6' Tubing":     '15806055',
  "Galv-1-5/8\" x 8' .065":       '15808080',
  "Galv-1-3/8\" x 21' Tubing":    '13821055',
  "Galv-1-5/8\" x 21' Mid Wt":    '15821080',
  "Galv-2\" x 6' Mid Wt":         '20006080',
  "Galv-2\" x 8' Mid Wt":         '20008080',
  "Galv-2 1/2\" x 6' Mid Wt":     '21206080',
  "Galv-2 1/2\" x 8' Mid Wt":     '21208080',
  "Galv-2 1/2\" x 9' Mid Wt":     '21209080',
  "Galv-2 1/2\" x 10'6\" Mid Wt": '21210080',
  "Galv-2 1/2\" x 12' Mid Wt":    '21212080',
  "Galv-3\" x 8' 40 Wt":          '30008120',
  "Galv-3\" x 10'6\" 40 Wt":      '30010120',
  "Galv-3\" x 12' 40 Wt":         '30012120',
  "Galv-4\" x 8' 40 Wt":          '40008120',
  "Galv-4\" x 10'6\" 40 Wt":      '40010120',
  "Galv-4\" x 12' 40 Wt":         '40012120',
  "Galv-6-5/8\" x 10'6\" 40 Wt":  '65810120',
  "Galv-6-5/8\" x 12' 40 Wt":     '65812120',
  "Black-1-5/8\" x 6' Tubing":     '15806055K',
  "Black-1-5/8\" x 8' .065":       '158820BK',
  "Black-1-3/8\" x 21' Tubing":    '13821055K',
  "Black-1-5/8\" x 21' Mid Wt":    '15821080K',
  "Black-2\" x 6' Mid Wt":         '20006080K',
  "Black-2\" x 8' Mid Wt":         '20008080K',
  "Black-2 1/2\" x 6' Mid Wt":     '21206080K',
  "Black-2 1/2\" x 8' Mid Wt":     '21208080K',
  "Black-2 1/2\" x 9' Mid Wt":     '21209080K',
  "Black-2 1/2\" x 10'6\" Mid Wt": '21210080K',
  "Black-2 1/2\" x 12' Mid Wt":    '21212080K',
  "Black-3\" x 8' 40 Wt":          '3840BK',
  "Black-3\" x 10'6\" 40 Wt":      '30010120K',
  "Black-3\" x 12' 40 Wt":         '30012120K',
  // ⚠️ VERIFY against price list: inferred from the 4" Black convention
  // (40012120K → 40008120K). Note 3"x8' Black breaks the pattern as '3840BK',
  // so this could instead be '4840BK'. Confirm before relying on it in quotes.
  "Black-4\" x 8' 40 Wt":          '40008120K',
  "Black-4\" x 12' 40 Wt":         '40012120K',
};

export const FITTING_SKU = {
  'Galv-TensionBand-1-3/8"':  '901',
  'Galv-TensionBand-1-5/8"':  '902',
  'Galv-TensionBand-2"':      '903',
  'Galv-TensionBand-2 1/2"':  '904',
  'Galv-TensionBand-3"':      '905',
  'Galv-TensionBand-4"':      '907',
  'Galv-TensionBand-6-5/8"':  '908',
  'Black-TensionBand-1-5/8"': '5902',
  'Black-TensionBand-2"':     '5903',
  'Black-TensionBand-2 1/2"': '5904',
  'Black-TensionBand-3"':     '5905',
  'Black-TensionBand-4"':     '5907',

  'Galv-TensionBar-36':   'TBAR036',
  'Galv-TensionBar-42':   'TBAR042',
  'Galv-TensionBar-48':   'TBAR048',
  'Galv-TensionBar-60':   'TBAR060',
  'Galv-TensionBar-72':   'TBAR072',
  'Galv-TensionBar-84':   'TBAR084',
  'Galv-TensionBar-96':   'TBAR096',
  'Galv-TensionBar-120':  'TBAR120',
  'Galv-TensionBar-144':  'TBAR144',
  'Black-TensionBar-36':  'TBAR036BK',
  'Black-TensionBar-42':  'TBAR042BK',
  'Black-TensionBar-48':  'TBAR048BK',
  'Black-TensionBar-60':  'TBAR060BK',
  'Black-TensionBar-72':  'TBAR072BK',
  'Black-TensionBar-84':  'TBAR084BK',
  'Black-TensionBar-96':  'TBAR096BK',
  'Black-TensionBar-120': 'TBAR120BK',
  'Black-TensionBar-144': 'TBAR144BK',

  'Galv-BraceBand-1-5/8"':  '922',
  'Galv-BraceBand-2"':      '923',
  'Galv-BraceBand-2 1/2"':  '924',
  'Galv-BraceBand-3"':      '925',
  'Galv-BraceBand-4"':      '927',
  'Galv-BraceBand-6-5/8"':  '928',
  'Black-BraceBand-1-5/8"': '5922',
  'Black-BraceBand-2"':     '5923',
  'Black-BraceBand-2 1/2"': '5924',
  'Black-BraceBand-3"':     '5925',
  'Black-BraceBand-4"':     '5927',
  'Black-BraceBand-6-5/8"': '5928',

  'Galv-RailEnd-1-3/8"':  '801',
  'Galv-RailEnd-1-5/8"':  '822',
  'Black-RailEnd-1-3/8"': '5801',
  'Black-RailEnd-1-5/8"': '5822',

  'Galv-PostCap-1-3/8"':  '841',
  'Galv-PostCap-1-5/8"':  '842',
  'Galv-PostCap-2"':      '843',
  'Galv-PostCap-2 1/2"':  '844',
  'Galv-PostCap-3"':      '845',
  'Galv-PostCap-4"':      '846',
  'Galv-PostCap-6-5/8"':  '847',
  'Black-PostCap-1-3/8"': '5841',
  'Black-PostCap-1-5/8"': '5842',
  'Black-PostCap-2"':     '5843',
  'Black-PostCap-2 1/2"': '5844',
  'Black-PostCap-3"':     '5845',
  'Black-PostCap-4"':     '5846',
  'Black-PostCap-6-5/8"': '5847',

  "Galv-LoopCap-1-5/8\" Post":    '810',
  "Galv-LoopCap-2\" Post":        '813',
  "Galv-LoopCap-2 1/2\" Post":    '814',
  "Galv-LoopCap-3\" Post":        '815',
  "Galv-LoopCap-4\" Post":        '817',
  "Galv-LoopCapRes-1-5/8\" Post": '811',
  "Galv-LoopCapRes-2\" Post":     '812',
  "Black-LoopCap-1-5/8\" Post":   '5811',
  "Black-LoopCap-2\" Post":       '5813',
  "Black-LoopCap-2 1/2\" Post":   '5814',
  "Black-LoopCap-3\" Post":       '5815',
  "Black-LoopCapRes-1-5/8\" Post": '5811',
  "Black-LoopCapRes-2\" Post":     '5812',

  // Barb Arms — 3-strand Standard (1 per line post, size matches line post diameter).
  // Used in place of Loop Caps when Barb Wire is selected (Commercial only).
  'Galv-BarbArm-1-5/8"':  '401',
  'Galv-BarbArm-2"':      '402',
  'Galv-BarbArm-2 1/2"':  '403',
  'Galv-BarbArm-3"':      '404',
  'Black-BarbArm-2"':     '5402',
  'Black-BarbArm-2 1/2"': '5403',
  'Black-BarbArm-3"':     '5404',
  // No Black 1-5/8" barb arm — barb wire is Commercial-only and Commercial line posts are 2"+.

  'Galv-Boulevard-1-5/8"':      '259',
  'Galv-Boulevard-2"':          '261',
  'Galv-Boulevard-2 1/2"':      '262',
  'Galv-Boulevard-3"':          '263',
  'Galv-Boulevard-4"':          '264',
  'Galv-BoulevardRes-1-3/8"':   '266',
  'Galv-BoulevardRes-1-5/8"':   '258',
  'Black-Boulevard-2"':         '5261',
  'Black-Boulevard-2 1/2"':     '5262',
  'Black-Boulevard-3"':         '5263',
  'Black-Boulevard-4"':         '5264',
  'Black-BoulevardRes-1-5/8"':  '5258',

  'AluminumTie-Short-Galv':  '9GST',
  'AluminumTie-Long-Galv':   '9GLT',
  'AluminumTie-Short-Black': '9GSTBK',
  'AluminumTie-Long-Black':  '9GLTBK',
  'Galv-HogRings':     'HR9AP',
  'Black-HogRings':    'HRBK',
  'CarriageBolt':      'CB',

  'Galv-CoilWire':  'CW170',
  'Black-CoilWire': 'CWBK170',
  'Galv-BarbWire':  'BW',
  'Black-BarbWire': 'BWBK',
};

export const CANTILEVER_SKU = {
  'Roller-3"':    '532',
  'Roller-4"':    '534',
  'Latch-3"':     '521',
  'Latch-4"':     '522',
  'LatchReceiver':'512',
};

// CANTILEVER GATE SKUs
// Format: CG + [Opening ft] + [Height ft]
// Available openings: 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30 ft
// Available heights: 4, 5, 6, 7, 8, 10, 12 ft
export const CANTILEVER_GATE_SKU = {
  // 10' Opening
  '10-4': 'CG104', '10-5': 'CG105', '10-6': 'CG106', '10-7': 'CG107',
  '10-8': 'CG108', '10-10': 'CG1010', '10-12': 'CG1012',
  // 12' Opening (no CG1212 in price list — getCantileverGateSKU returns an error for 12'×12')
  '12-4': 'CG124', '12-5': 'CG125', '12-6': 'CG126', '12-7': 'CG127',
  '12-8': 'CG128', '12-10': 'CG1210',
  // 14' Opening
  '14-4': 'CG144', '14-5': 'CG145', '14-6': 'CG146', '14-7': 'CG147',
  '14-8': 'CG148', '14-10': 'CG1410', '14-12': 'CG1412',
  // 16' Opening
  '16-4': 'CG164', '16-5': 'CG165', '16-6': 'CG166', '16-7': 'CG167',
  '16-8': 'CG168', '16-10': 'CG1610', '16-12': 'CG1612',
  // 18' Opening
  '18-4': 'CG184', '18-5': 'CG185', '18-6': 'CG186', '18-7': 'CG187',
  '18-8': 'CG188', '18-10': 'CG1810', '18-12': 'CG1812',
  // 20' Opening
  '20-4': 'CG204', '20-5': 'CG205', '20-6': 'CG206', '20-7': 'CG207',
  '20-8': 'CG208', '20-10': 'CG2010', '20-12': 'CG2012',
  // 22' Opening
  '22-4': 'CG224', '22-5': 'CG225', '22-6': 'CG226', '22-7': 'CG227',
  '22-8': 'CG228', '22-10': 'CG2210', '22-12': 'CG2212',
  // 24' Opening
  '24-4': 'CG244', '24-5': 'CG245', '24-6': 'CG246', '24-7': 'CG247',
  '24-8': 'CG248', '24-10': 'CG2410', '24-12': 'CG2412',
  // 26' Opening
  '26-4': 'CG264', '26-5': 'CG265', '26-6': 'CG266', '26-7': 'CG267',
  '26-8': 'CG268', '26-10': 'CG2610', '26-12': 'CG2612',
  // 28' Opening
  '28-4': 'CG284', '28-5': 'CG285', '28-6': 'CG286', '28-7': 'CG287',
  '28-8': 'CG288', '28-10': 'CG2810', '28-12': 'CG2812',
  // 30' Opening
  '30-4': 'CG304', '30-5': 'CG305', '30-6': 'CG306', '30-7': 'CG307',
  '30-8': 'CG308', '30-10': 'CG3010', '30-12': 'CG3012',
};

// Available standard openings (feet) — ascending, used for round-up matching
export const CANTILEVER_OPENINGS_FT = [10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30];

// Available standard heights (feet) — ascending, used for round-up matching
export const CANTILEVER_HEIGHTS_FT = [4, 5, 6, 7, 8, 10, 12];

/**
 * Find the Cantilever Gate SKU for a given opening (inches) and fence height (feet).
 * Rounds UP to the next available standard size when the input doesn't match exactly.
 *
 * Example:
 *   getCantileverGateSKU(120, 6) → { sku: 'CG106', openingFt: 10, heightFt: 6 }
 *   getCantileverGateSKU(122, 6) → { sku: 'CG126', openingFt: 12, heightFt: 6 } (rounded up)
 *   getCantileverGateSKU(155, 8) → { sku: 'CG168', openingFt: 16, heightFt: 8 }
 *   getCantileverGateSKU(144, 12) → { sku: null, error: '...' } (no CG1212 in price list)
 */
export function getCantileverGateSKU(openingInches, fenceHeightFt) {
  const openingFt = (parseFloat(openingInches) || 0) / 12;
  const heightFt = parseFloat(fenceHeightFt) || 0;

  // Find the next available opening size (round UP)
  const matchingOpening = CANTILEVER_OPENINGS_FT.find(ft => ft >= openingFt);
  if (!matchingOpening) {
    return {
      sku: null, openingFt: null, heightFt: null,
      error: `Opening of ${openingFt.toFixed(1)}ft exceeds maximum size of 30ft for Cantilever Gates.`,
    };
  }

  // Find the next available height (round UP)
  const matchingHeight = CANTILEVER_HEIGHTS_FT.find(ft => ft >= heightFt);
  if (!matchingHeight) {
    return {
      sku: null, openingFt: matchingOpening, heightFt: null,
      error: `Height of ${heightFt}ft exceeds maximum of 12ft for Cantilever Gates.`,
    };
  }

  const key = `${matchingOpening}-${matchingHeight}`;
  const sku = CANTILEVER_GATE_SKU[key];
  if (!sku) {
    return {
      sku: null, openingFt: matchingOpening, heightFt: matchingHeight,
      error: `No Cantilever Gate SKU exists for ${matchingOpening}' x ${matchingHeight}'.`,
    };
  }

  return { sku, openingFt: matchingOpening, heightFt: matchingHeight, error: null };
}

// Standard swing-gate sizes (feet), ascending — used for round-up matching.
// Residential single gates additionally offer a 42" (3.5') opening, and residential
// gates support a 42" (3.5') height; both are represented as 3.5 below.
export const SWING_SINGLE_OPENINGS_FT = [3, 4, 5, 6];
export const SWING_DOUBLE_OPENINGS_FT = [10, 12, 14, 16, 18, 20, 22, 24, 26];
export const SWING_GATE_HEIGHTS_FT = [4, 5, 6, 7, 8, 10, 12];

/**
 * Resolve a swing gate's opening (inches) and fence height (feet) to the next
 * available standard size, rounding UP, and build the pre-built gate frame SKU.
 * The round-up rule is universal — it applies to both Residential and Commercial.
 *
 * Residential single gates also offer a 42" opening, and residential gates support
 * a 42" height (both shown as 3.5'); these map to the '42' SKU code.
 *
 * Frame SKU encoding:
 *   - Commercial single:          <opening><height>1S15S (1-5/8" frame)
 *   - Commercial double, < 20':   <opening><height>1S15D
 *   - Commercial double, >= 20':  <opening><height>2S20D (2" frame), + 'BK' if Black
 *   - Residential:                <openingCode><heightCode>[D][B]  (D = double, B = black)
 *
 * Example: 4'×6' commercial single galv → '461S15S'; 4'×6' residential single galv → '46'.
 *
 * Returns: { sku, openingFt, heightFt, openingLabel, heightLabel, wasRounded, outOfRange }.
 * `outOfRange` means the entered opening exceeds the largest size for the type (it is
 * then clamped to the largest available).
 */
export function getSwingGateSize(openingInches, fenceHeightFt, gateType, fenceClass, isBlack) {
  const isDouble = gateType === 'Double Swing';
  const isRes = fenceClass === 'Residential';
  const widthFt = (parseFloat(openingInches) || 0) / 12;
  const heightEntered = parseFloat(fenceHeightFt) || 0;

  // Opening sizes — residential single gates add a 42" (3.5') option.
  let openings = isDouble ? SWING_DOUBLE_OPENINGS_FT : SWING_SINGLE_OPENINGS_FT;
  if (isRes && !isDouble) openings = [3, 3.5, 4, 5, 6];

  let openingFt = openings.find(o => o >= widthFt);
  let outOfRange = false;
  if (!openingFt) { openingFt = openings[openings.length - 1]; outOfRange = true; }

  // Height sizes — residential gates add a 42" (3.5') option.
  const heights = isRes ? [3.5, ...SWING_GATE_HEIGHTS_FT] : SWING_GATE_HEIGHTS_FT;
  let heightFt = heights.find(hh => hh >= heightEntered);
  if (!heightFt) heightFt = heights[heights.length - 1];

  const wasRounded = openingFt !== widthFt || heightFt !== heightEntered;
  const openingLabel = openingFt === 3.5 ? '42"' : `${openingFt}'`;
  const heightLabel = heightFt === 3.5 ? '42"' : `${heightFt}'`;

  let sku;
  if (isRes) {
    const openingCode = openingFt === 3.5 ? '42' : String(openingFt);
    const heightCode = heightFt === 3.5 ? '42' : String(heightFt);
    sku = `${openingCode}${heightCode}${isDouble ? 'D' : ''}${isBlack ? 'B' : ''}`;
  } else {
    let suffix;
    if (!isDouble)           suffix = '1S15S';
    else if (openingFt < 20) suffix = '1S15D';
    else                     suffix = '2S20D';
    sku = `${openingFt}${heightFt}${suffix}${isBlack ? 'BK' : ''}`;
  }

  return { sku, openingFt, heightFt, openingLabel, heightLabel, wasRounded, outOfRange };
}

export const GATE_HW_SKU = {
  // ===== RESIDENTIAL =====
  // Female Hinges (gate frame side)
  'Residential-FemaleHinge-1-3/8"-Galv':  '221',
  'Residential-FemaleHinge-1-3/8"-Black': '5221',
  'Residential-FemaleHinge-1-5/8"-Galv':  '222',
  'Residential-FemaleHinge-1-5/8"-Black': '5222',

  // Male Hinges (gate post side)
  'Residential-MaleHinge-1-3/8"-Galv':    '211',
  'Residential-MaleHinge-1-5/8"-Galv':    '212',
  'Residential-MaleHinge-2"-Galv':        '213',
  'Residential-MaleHinge-2"-Black':       '5213',
  'Residential-MaleHinge-2 1/2"-Galv':    '214',
  'Residential-MaleHinge-2 1/2"-Black':   '5214',
  'Residential-MaleHinge-3"-Galv':        '215',
  'Residential-MaleHinge-3"-Black':       '5215',
  // Note: Male Hinge 1-3/8"/1-5/8" Black SKUs not yet confirmed.

  // Fork Latches (sized to latch post diameter)
  'Residential-ForkLatch-1-3/8"-Galv':    '231',
  'Residential-ForkLatch-1-3/8"-Black':   '5231',
  'Residential-ForkLatch-2"-Galv':        '232',
  'Residential-ForkLatch-2"-Black':       '5232',
  'Residential-ForkLatch-2 1/2"-Galv':    '233',
  'Residential-ForkLatch-2 1/2"-Black':   '5233',

  // Collars (residential gate frames are 1-3/8")
  'Residential-Collar-1-3/8"-Galv':       '241',
  'Residential-Collar-1-3/8"-Black':      '5241',

  // Drop Rod (for double swing)
  'Residential-DropRod-Galv':             '985',
  'Residential-DropRod-Black':            '0985B',

  // ===== COMMERCIAL =====
  // IOH (Industrial Offset Hinges) — sized to gate post diameter
  'Commercial-IOHHinge-2 1/2"-Galv':      '501',
  'Commercial-IOHHinge-2 1/2"-Black':     '5501',
  'Commercial-IOHHinge-3"-Galv':          '502',
  'Commercial-IOHHinge-3"-Black':         '5502',
  'Commercial-IOHHinge-4"-Galv':          '503',
  'Commercial-IOHHinge-4"-Black':         '5503',
  'Commercial-IOHHinge-6-5/8"-Galv':      '504',
  'Commercial-IOHHinge-6-5/8"-Black':     '5504', // *NOT IN STOCK

  // Fork Latches (shared with residential, sized to latch post diameter)
  'Commercial-ForkLatch-1-3/8"-Galv':     '231',
  'Commercial-ForkLatch-1-3/8"-Black':    '5231',
  'Commercial-ForkLatch-2"-Galv':         '232',
  'Commercial-ForkLatch-2"-Black':        '5232',
  'Commercial-ForkLatch-2 1/2"-Galv':     '233',
  'Commercial-ForkLatch-2 1/2"-Black':    '5233',
  'Commercial-ForkLatch-3"-Galv':         '234',
  'Commercial-ForkLatch-3"-Black':        '5234',
  'Commercial-ForkLatch-4"-Galv':         '235',
  // Note: Fork Latch 4" Black SKU not yet confirmed.

  // Collars (commercial gate frames are 1-5/8")
  'Commercial-Collar-1-5/8"-Galv':        '242',
  'Commercial-Collar-1-5/8"-Black':       '5242',

  // ILD (Industrial Locking Device, for double swing)
  'Commercial-ILD-Galv':                  '200',
  'Commercial-ILD-Black':                 '5200',
};

export const POST_OPTIONS = {
  Residential: {
    '3':   {
      endCorner: { default: "2\" x 6' Mid Wt", options: ["2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      line:      { default: "1-5/8\" x 6' Tubing", options: ["1-5/8\" x 6' Tubing"] },
      rail: "1-3/8\" x 21' Tubing",
    },
    '3.5': {
      endCorner: { default: "2\" x 6' Mid Wt", options: ["2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      line:      { default: "1-5/8\" x 6' Tubing", options: ["1-5/8\" x 6' Tubing"] },
      rail: "1-3/8\" x 21' Tubing",
    },
    '4':   {
      endCorner: { default: "2\" x 6' Mid Wt", options: ["2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      line:      { default: "1-5/8\" x 6' Tubing", options: ["1-5/8\" x 6' Tubing"] },
      rail: "1-3/8\" x 21' Tubing",
    },
    '5':   {
      endCorner: { default: "2\" x 8' Mid Wt", options: ["2\" x 8' Mid Wt", "2 1/2\" x 8' Mid Wt"] },
      line:      { default: "1-5/8\" x 8' .065", options: ["1-5/8\" x 8' .065"] },
      rail: "1-3/8\" x 21' Tubing",
    },
    '6':   {
      endCorner: { default: "2\" x 8' Mid Wt", options: ["2\" x 8' Mid Wt", "2 1/2\" x 8' Mid Wt", "2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      line:      { default: "1-5/8\" x 8' .065", options: ["1-5/8\" x 8' .065", "1-5/8\" x 6' Tubing"] },
      rail: "1-3/8\" x 21' Tubing",
    },
  },
  Commercial: {
    '3':   {
      endCorner: { default: "2 1/2\" x 6' Mid Wt", options: ["2 1/2\" x 6' Mid Wt", "3\" x 8' 40 Wt"] },
      line:      { default: "2\" x 6' Mid Wt", options: ["2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '3.5': {
      endCorner: { default: "2 1/2\" x 6' Mid Wt", options: ["2 1/2\" x 6' Mid Wt", "3\" x 8' 40 Wt"] },
      line:      { default: "2\" x 6' Mid Wt", options: ["2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '4':   {
      endCorner: { default: "2 1/2\" x 6' Mid Wt", options: ["2 1/2\" x 6' Mid Wt", "3\" x 8' 40 Wt"] },
      line:      { default: "2\" x 6' Mid Wt", options: ["2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '5':   {
      endCorner: { default: "2 1/2\" x 8' Mid Wt", options: ["2 1/2\" x 8' Mid Wt", "3\" x 8' 40 Wt", "4\" x 8' 40 Wt"] },
      line:      { default: "2\" x 8' Mid Wt", options: ["2\" x 8' Mid Wt", "2 1/2\" x 8' Mid Wt", "3\" x 8' 40 Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '6':   {
      endCorner: { default: "2 1/2\" x 9' Mid Wt", options: ["2 1/2\" x 8' Mid Wt", "2 1/2\" x 9' Mid Wt", "3\" x 8' 40 Wt", "3\" x 10'6\" 40 Wt", "4\" x 8' 40 Wt", "4\" x 10'6\" 40 Wt", "2 1/2\" x 6' Mid Wt"] },
      line:      { default: "2\" x 8' Mid Wt", options: ["2\" x 8' Mid Wt", "2 1/2\" x 8' Mid Wt", "3\" x 8' 40 Wt", "2\" x 6' Mid Wt", "2 1/2\" x 6' Mid Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '7':   {
      endCorner: { default: "3\" x 10'6\" 40 Wt", options: ["3\" x 10'6\" 40 Wt", "4\" x 10'6\" 40 Wt"] },
      line:      { default: "2 1/2\" x 9' Mid Wt", options: ["2 1/2\" x 9' Mid Wt", "3\" x 10'6\" 40 Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '8':   {
      endCorner: { default: "3\" x 10'6\" 40 Wt", options: ["3\" x 10'6\" 40 Wt", "3\" x 12' 40 Wt", "4\" x 10'6\" 40 Wt", "4\" x 12' 40 Wt", "2 1/2\" x 8' Mid Wt", "3\" x 8' 40 Wt", "4\" x 8' 40 Wt"] },
      line:      { default: "2 1/2\" x 10'6\" Mid Wt", options: ["2 1/2\" x 10'6\" Mid Wt", "2 1/2\" x 12' Mid Wt", "3\" x 10'6\" 40 Wt", "3\" x 12' 40 Wt", "2\" x 8' Mid Wt", "2 1/2\" x 8' Mid Wt", "3\" x 8' 40 Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '10':  {
      endCorner: { default: "3\" x 12' 40 Wt", options: ["3\" x 12' 40 Wt", "4\" x 12' 40 Wt"] },
      line:      { default: "2 1/2\" x 12' Mid Wt", options: ["2 1/2\" x 12' Mid Wt", "3\" x 12' 40 Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
    '12':  {
      endCorner: { default: "3\" x 12' 40 Wt", options: ["3\" x 12' 40 Wt", "4\" x 12' 40 Wt"] },
      line:      { default: "2 1/2\" x 12' Mid Wt", options: ["2 1/2\" x 12' Mid Wt", "3\" x 12' 40 Wt"] },
      rail: "1-5/8\" x 21' Mid Wt",
    },
  },
};

// End/corner post overrides when barb wire is active (Commercial only, heights 5-8)
export const BARB_WIRE_OPTIONS = {
  '5': { endCorner: { options: ["2 1/2\" x 10'6\" Mid Wt", "3\" x 10'6\" 40 Wt", "4\" x 10'6\" 40 Wt"] } },
  '6': { endCorner: { options: ["2 1/2\" x 10'6\" Mid Wt", "3\" x 10'6\" 40 Wt"] } },
  '7': { endCorner: { options: ["3\" x 12' 40 Wt", "4\" x 12' 40 Wt"] } },
  '8': { endCorner: { options: ["3\" x 12' 40 Wt", "4\" x 12' 40 Wt"] } },
};

// Extracts the nominal diameter from a post size string, e.g. '2 1/2" x 8' Mid Wt' → '2 1/2"'
export function getPostDiameter(postSize) {
  if (!postSize) return '';
  const m = postSize.match(/^([\d\-\s/]+")/);
  return m ? m[1].trim() : '';
}

export function getTensionBarLength(height) {
  const h = parseFloat(height);
  if (h === 3)   return 36;
  if (h === 3.5) return 42;
  if (h === 4)   return 48;
  if (h === 5)   return 60;
  if (h === 6)   return 72;
  if (h === 7)   return 84;
  if (h === 8)   return 96;
  if (h === 10)  return 120;
  if (h === 12)  return 144;
  return 48;
}

// Returns gate post size options (full size strings) for the gate modal.
// opening is the gate width in inches (string or number).
// finish is 'Galvanized' or 'Black'.
export function getGatePostOptions(fenceClass, height, gateType, opening = '', finish = 'Galvanized') {
  const openingIn = parseFloat(opening) || 0;
  const isBlack = finish === 'Black';

  if (fenceClass === 'Residential') {
    return POST_OPTIONS.Residential?.[height]?.endCorner?.options || [];
  }

  // Commercial — Cantilever: 3" or 4" only, order by opening size
  if (gateType === 'Cantilever') {
    if (openingIn >= 192) {
      // ≥ 16 ft: prefer 4"
      return ["4\" x 10'6\" 40 Wt", "4\" x 12' 40 Wt", "3\" x 10'6\" 40 Wt", "3\" x 12' 40 Wt"];
    }
    return ["3\" x 10'6\" 40 Wt", "3\" x 12' 40 Wt", "4\" x 10'6\" 40 Wt", "4\" x 12' 40 Wt"];
  }

  // Commercial Double Swing ≥ 26 ft (312"): add 6-5/8" options (Galv only)
  if (gateType === 'Double Swing' && openingIn >= 312) {
    const large = ["4\" x 10'6\" 40 Wt", "4\" x 12' 40 Wt"];
    if (!isBlack) {
      large.push("6-5/8\" x 10'6\" 40 Wt", "6-5/8\" x 12' 40 Wt");
    }
    return large;
  }

  // All other commercial swing gates: use height-based end/corner options
  return POST_OPTIONS.Commercial?.[height]?.endCorner?.options || [];
}